<template>

  <v-dialog v-if="isDialogRendered" v-model="value" :width="400" :fullscreen="$vuetify.breakpoint.xsOnly"
    :content-class="'app-dialog promo-action-dlg ' + ($vuetify.breakpoint.xsOnly ? 'mobile' : '')" :persistent="!isPreview"
    @input="onClosed">

    <v-card>

      <v-card-text class="main-container pa-0 text-center">

        <div class="image-container pt-5">
          <img :src="promoActionDetails.image" :alt="promoAction.code" />
        </div>

        <div class="text-main-container pa-5">
          <span style="white-space: pre-line">{{ decodeURIComponent(promoActionDetails.greetings) }}</span>
        </div>

        <div class="text-sub-container py-2 d-flex justify-center">
          <div style="width: 60%; white-space: pre-line;">
            {{ decodeURIComponent(promoActionDetails.wishes) }}
          </div>
        </div>

        <div class="footer-container d-flex pa-5 align-center">

          <div class="free-delivery-container d-flex" style="flex-basis: 50%">

            <table>
              <tr>
                <td><img :src="presentIconUrl" alt="present" style="vertical-align: bottom;" class="mb-1" /></td>
                <td v-if="isBonusGot" class="text-left pl-2 primary--text font-weight-bold" rowspan="2">
                  {{ $t('appPromoActionsUserHolidayDlg.labels.freeDeliveriesGot') }}
                </td>
                <td v-else class="text-left pl-2" style="vertical-align: bottom;">
                  {{ $t('appPromoActionsUserHolidayDlg.labels.give') }}
                </td>
              </tr>
              <tr>
                <td style="vertical-align: top;">
                  <div class="primary--text text-h4 font-weight-bold">
                    {{ promoAction.freeDeliveryNumber }}
                  </div>
                </td>
                <td v-if="!isBonusGot" class="text-left pl-2 primary--text"
                  style="line-height: initial; vertical-align: top; display: inline-block; width: min-content;">
                  {{ $t('appPromoActionsUserHolidayDlg.labels.freeDeliveries') }}
                </td>
              </tr>
            </table>

          </div>

          <div class="btn-container" style="flex-basis: 50%">
            <v-btn v-if="isParticipateBtnVisible" color="primary" class="text-subtitle-1" style="width: 100%; text-transform: uppercase"
              @click="participate">
              {{ $t('appPromoActionsUserHolidayDlg.labels.participate') }}
            </v-btn>
            <v-btn v-if="isCloseBtnVisible" color="secondary" class="text-subtitle-1" style="width: 100%" @click="close">
              {{ $t('buttons.close') }}
            </v-btn>
          </div>

        </div>

      </v-card-text>

    </v-card>

  </v-dialog>

</template>

<script>
import uiMixin from '@/mixins/ui-mixin';
import { PromoActionUserStatus } from '@/models/enums';
import { AppError } from '@/models/log.models';
import { actions as _act } from '@/models/store.actions';
import { promoActionsService } from '@/services/promo-actions.service';
import { logHelper } from '@/helpers';
import { PromoActionUser, PromoActionUserDetails } from '@/models/promo-actions.models';
import { logger } from '@/helpers/log.service';

export default {
  name: 'AppPromoActionsUserHolidayDlg',
  mixins: [uiMixin],
  inject: ['baseUrl'],
  props: {
    promoAction: { type: PromoActionUser, default: () => new PromoActionUser(null) },
    isPreview: { type: Boolean, default: false }
  },
  data() {
    return {
      value: true,
      iconsRelativePath: 'static/promotion',
      isViewedStatusSettingRequired: true,
      promoActionDetails: new PromoActionUserDetails()
    };
  },
  computed: {
    iconsPath() {
      return `${this.baseUrl}${this.iconsRelativePath}`;
    },
    presentIconUrl() {
      return `${this.iconsPath}/icons_present.svg`;
    },
    isValidPromotion() {
      return this.promoAction && this.promoAction.uid;
    },
    isDialogRendered() {
      return this.isValidPromotion && this.promoActionDetails.greetings;
    },
    isParticipateBtnVisible() {
      return this.promoAction.dateParticipate === null;
    },
    isCloseBtnVisible() {
      return !this.isParticipateBtnVisible;
    },
    isBonusGot() { return !this.isPreview && this.promoAction.dateParticipate !== null; }
  },
  mounted() {
    this.loadPromoActionDetails();
  },
  methods: {
    async loadPromoActionDetails() {
      if (this.isValidPromotion) {
        const loader = this.showLoading();
        try {
          this.promoActionDetails = await promoActionsService.getPromoActionDetails(this.promoAction.uid);
          logger.debug(`[AppPromoActionsUserHolidayDlg:loadPromoActionDetails]`, this.promoActionDetails);
        } catch (err) {
          if (!(err instanceof AppError)) { logHelper.error(err); }
        } finally {
          loader.hide();
        }
      }
    },
    async close() {
      await this.markPromoAsViewed();
      this.closeDlg();
    },
    closeDlg() {
      this.isViewedStatusSettingRequired = false;
      this.value = false;
    },
    async markPromoAsViewed() {
      if (this.promoAction && this.promoAction.dateView === null && !this.isPreview) {
        await this.updateUserPromoActionStatus(PromoActionUserStatus.Viewed);
      }
    },
    async participate() {
      if (this.isPreview) return;

      await this.updateUserPromoActionStatus(PromoActionUserStatus.Participated);
      await this.$store.dispatch(_act.DOC_ACT_LOADBALANCE);
      this.closeDlg();
    },
    async updateUserPromoActionStatus(status) {
      const loader = this.showLoading();
      try {
        await promoActionsService.changeUserPromoActionStatus(this.promoAction.uid, status);
      } catch (err) {
        if (!(err instanceof AppError)) { logHelper.error(err); }
      } finally {
        loader.hide();
      }
    },
    onClosed() {
      this.$emit('closed');
    }
  },
  watch: {
    value(newVal) {
      if (newVal === false && this.isViewedStatusSettingRequired) {
        this.markPromoAsViewed();
      }
    },
    promoAction(newVal) {
      this.value = !!newVal;
      this.loadPromoActionDetails();
    }
  }
};
</script>

<style lang="scss">
.promo-action-dlg {
  .main-container {
    .text-main-container {
      font-weight: 300;
      font-size: 1.75em;
    }

    .text-sub-container {
      background-color: var(--v-info-base);
      color: var(--v-primary-base);
      line-height: initial;
    }
  }
}
</style>
